import React, { useEffect, useState } from "react";
import { useFormik,} from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import "jspdf-autotable"; import {  Row, Col,Container,} from "react-bootstrap"; import { generatePdf, exportToExcel, datetime } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import useAlert from "../Alert/useAlert"; import AlertModal from "../Alert/AlertModal"; import { IoIosReturnLeft } from "react-icons/io";
export default function MappedOfficersCount() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();let district = localStorage.getItem("districtid"); const [Mainenb, setMainenb] = useState([]); const [Empdata, setEmpdata] = useState([]); const [distEnb, setDistEnb] = useState(false); const [mandalenb, setmandalenb] = useState(false); const [searchText1, setSearch1] = useState(""); const[currentdate,setcurrentdate] =useState(''); const[currenttime,setcurrenttime] =useState(''); let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid");
  
  const formik = useFormik({
    initialValues: { department_id:"", district_id: "0", mandal_id:"" },

  })


useEffect(() => { datetime(setcurrentdate,setcurrenttime); let params={ userId: username}; setMainenb(true); getdata(params,""); }, []);


const filteredDataa =
      searchText1.length > 0 && Empdata?.length
        ? Empdata.filter((item) => {
            return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()) );
              })
            );
          })
        : Empdata;

 const getdata=(params,type)=>{
  store.dispatch({ type: "SHOW_SPINNER" });
     KpiService.getMappedOfficersCount(params).then((res) => {
          if (res?.data?.SCODE === "01") {
            if(type === "District"){ setMainenb(false); setmandalenb(false); setDistEnb(true); }
              if(type === "Mandal"){ setMainenb(false); setDistEnb(false); setmandalenb(true); } if(type === ""){ setmandalenb(false); setDistEnb(false); setMainenb(true); }
            setEmpdata(res.data?.dataList);
          } 
          else {
            if (res?.data?.SCODE === "03"){
  
            }
            const message = res?.data?.SDESC || "Unexpected response format.";
            showAlertMessage(message, "warning",()=>{ setEmpdata([])});
          }
        }).catch((error) => {
          console.error("Error fetching data:", error);
          showAlertMessage("Error fetching data. Please try again.", "warning");
        }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
 }
        const DistrictData=(val,type)=>{
          let params={ userId: username, deptId:val,type:type,distId:roleid==="119"? district :"0"};
       getdata(params,type);
        }
          const MandalData=(val,type)=>{ let params={ userId: username, deptId:val,type:type,distId:roleid==="119"? district :"0"}; getdata(params,type); }

         const BackFunct=()=>{
          let params={ userId: username}
          getdata(params,"");
        }
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  > <div className='sa-title'> <h2>Department Wise - Employee Mapping <span>Status Report</span></h2> </div> </Container>

      <DESUI.Container fluid style={{ width: "87%" }} className="outer-page-content-container">
       
        <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
              </Col>

           
                                  <Col className="mb-2">
                                  <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "MappedEmployeesStatusReport",distEnb ? 3 :4)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>

  <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "MappedEmployeesStatusReport")} > Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>

  {!Mainenb && ( <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={() => { BackFunct(); }} > <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> )}
</Col>

            </Row>
 
        
              <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="border py-2 px-2 " > <span className="style-1">Department Wise Mapped Employees Details </span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div> </div>
          
           <div id="table-scroll"  style={{ maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden' }} >
            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}> <tr className="text-center only-export"> <th colSpan={distEnb ? 3 :4 }> <span className="style-1">Mapped Employees Details </span> </th></tr> <tr className="only-export"><th  colSpan={distEnb ? 3 :4 }><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr> <tr className="text-center"> <th  > Sl No. </th> <th style={{whiteSpace: "normal", wordWrap: "break-word", maxWidth: "200px" }} >Department</th> {Mainenb &&<> <th  > District Mapped Officers Count</th> <th  > Mandal  Mapped Officers Count </th></>} {distEnb && <> <th  > District Name</th></>} {mandalenb&& <> <th  > District Name</th> <th  > Mandal Name</th> </>} </tr> </thead>
                <tbody>
                  {filteredDataa?.length === 0 || filteredDataa?.length === undefined ? ( <tr> <td className="text-center" colSpan={distEnb ? 3 :4 }> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                  ) : (
                    (() => {

                      return filteredDataa?.map((detail, i) => {
                        return (
                          <tr key={i}>
                            <td style={{textAlign:"center"}}>{i+1}</td>
                           <td style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "200px"}}>{detail.dept_name}</td> {Mainenb &&<> {detail.district_mapped_users_count !== 0 ? <td style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif",textAlign:"right" }} onClick={() => {DistrictData(detail.dept_id,"District");}}>{detail.district_mapped_users_count}</td>: <td style={{textAlign:"right"}}>{detail.district_mapped_users_count}</td>} {detail.mandal_mapped_users_count !== 0 ? <td style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif",textAlign:"right" }} onClick={() => {MandalData(detail.dept_id,"Mandal");}}>{detail.mandal_mapped_users_count}</td>: <td style={{textAlign:"right"}}>{detail.mandal_mapped_users_count}</td>} </>}
                           {distEnb && <> <td >{detail.district_name}</td> </>} {mandalenb && <> <td >{detail.district_name}</td> <td >{detail.mandal_name}</td> </>}
                        
                          </tr>
                        );
                      });
                    })()
                  )}
                </tbody>

              </table>

</div>
           
<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </DESUI.Container >
    </>
  );
};



